// src/utils/scrollReset.ts

/**
 * This utility implements multiple strategies to ensure scroll is always reset
 * when navigating between pages in the application
 */

/**
 * Configure scroll behavior for React Router
 * Call this function in your BrowserRouter configuration
 */
export const configureScrollBehavior = () => {
  // Override browser history methods to force scroll reset
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  // Override pushState
  window.history.pushState = function(...args) {
    // Call original method
    const result = originalPushState.apply(this, args);
    
    // Force scroll to top
    window.scrollTo(0, 0);
    
    // Dispatch an event for any listeners
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    
    return result;
  };

  // Override replaceState
  window.history.replaceState = function(...args) {
    // Call original method
    const result = originalReplaceState.apply(this, args);
    
    // Force scroll to top
    window.scrollTo(0, 0);
    
    // Dispatch an event for any listeners
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
    
    return result;
  };

  // Listen for popstate events (back/forward navigation)
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
    window.dispatchEvent(new Event('locationchange'));
  });
};

/**
 * Force scroll to top immediately
 * Can be called at any time to reset scroll position
 */
export const forceScrollToTop = () => {
  // Immediate scroll
  window.scrollTo(0, 0);
  
  // Backup scroll after a small delay
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
  
  // Additional backup for slower pages
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
};

/**
 * Patch Link component behavior 
 * This function can be used as a utility for navigation links
 */
export const handleLinkClick = () => {
  // Force scroll reset on link click
  forceScrollToTop();
};
